import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from '../../../public-api';
import { AbstractService } from '../../commons/abstract.service';

@Injectable({ providedIn: 'root' })
export class PaymentService extends AbstractService<Company> {

  getURLBase(): string {
    return '/payment';
  }

  constructor(private http: HttpClient) {
    super(http);
  }

  preCreate(obj: Company): void {
    delete obj?._id;
  }

  preUpdate(obj: Company): void {
  }

  getStripePlans(env: string): Observable<object> {
    return super.get(`/stripe/plans/${env}`);
  }

  stripeCreateCheckoutSession(priceId: string): Observable<string> {
    return super.post(`/stripe/create-checkout-session`, { priceId });
  }

  getBillingDetails(companyId: string): Observable<any> {
    return super.get(`/billing/${companyId}`);
  }

  getDetailsHistory(customerId: string): Observable<any> {
    return super.get(`/billing/${customerId}/history`);
  }

  getAsaasPlans(env: string): Observable<object> {
    return super.get(`/asaas/plans/${env}`);
  }

  asaasCreateCheckoutSession(priceId: string): Observable<string> {
    return super.post(`/asaas/create-checkout-session`, { priceId });
  }

  /** Typed catalog — SPEC-2026-08-typed-wallets RF-47. */
  getCreditPackages(walletType: string): Observable<Record<string, { id: string; name: string; price: number; credits: number }>> {
    return super.getWithParams('/asaas/credit/packages', { type: walletType });
  }

  createCreditPayment(packageKey: string, walletType: string): Observable<{ invoiceUrl: string }> {
    return super.post('/asaas/credit/create-payment', { packageKey, walletType });
  }

  /** @deprecated superseded by createCreditPayment; kept one release for old bundles. */
  asaasCreatePaymentCreditsWithCustomer(packageKey: string): Observable<string> {
    return super.post(`/asaas/ai/credit/create-payment`, { packageKey });
  }

}
